// Lucide icon: star (https://lucide.dev/icons/star)
import { Star } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconStarSolid = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled $filled {...props}>
      <Star strokeWidth={0} />
    </IconComponentStyled>
  )
}
